/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import { BasicApp } from "@ef/components-app";
import AppContext, { AppConfig } from "@ef/components-app/AppContext";

import { ThemeWrapper } from "@ef/theme-basic";

import TplEditApp from "./TplEditApp";

export default function App(config: AppConfig) {
    React.useEffect(() => {
        TplEditApp.useHistory(config.history);
        TplEditApp.init();
    }, [config.history]);
    return (
        <AppContext.Provider value={config}>
            <Provider store={TplEditApp.getStore()}>
                <ThemeWrapper>
                    <I18nextProvider i18n={i18n}>
                        <BasicApp />
                    </I18nextProvider>
                </ThemeWrapper>
            </Provider>
        </AppContext.Provider>
    );
}
